import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { CTAButton } from './CTAButton';
const tomos = [{
  num: 1,
  title: 'La Verdad Sobre Tu Dolor'
}, {
  num: 2,
  title: 'El Mapa del Supermercado Argentino'
}, {
  num: 3,
  title: 'La Semana de Choque (Días 1–7)'
}, {
  num: 4,
  title: 'Reconstrucción (Días 8–14)'
}, {
  num: 5,
  title: 'Consolidación (Días 15–21)'
}, {
  num: 6,
  title: 'Vida Real con Endo'
}];
export function SolutionSection() {
  return <section className="w-full bg-white py-16 px-5 flex justify-center" data-id="element-120">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col gap-8" data-id="element-121">
        <div className="flex flex-col gap-3" data-id="element-122">
          <h2 className="font-serif font-bold text-petroleo text-3xl leading-tight" data-id="element-123">
            Protocolo Endo-Rescate: 21 días para apagar el fuego que nadie ve.
          </h2>
          <p className="text-gray-600 text-base" data-id="element-124">
            Un plan diario, claro y acompañante para mujeres argentinas con
            endometriosis o inflamación hormonal crónica.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3" data-id="element-125">
          {tomos.map(tomo => <div key={tomo.num} className="bg-marfil border border-salvia-light rounded-xl p-4 flex flex-col gap-2 shadow-sm" data-id="element-126">
              <div className="bg-white w-8 h-8 rounded-full flex items-center justify-center shadow-sm" data-id="element-127">
                <BookOpen className="w-4 h-4 text-salvia" data-id="element-128" />
              </div>
              <div data-id="element-129">
                <p className="text-[10px] font-bold text-salvia uppercase tracking-wider mb-1" data-id="element-130">
                  Tomo {tomo.num}
                </p>
                <p className="font-semibold text-petroleo text-sm leading-tight" data-id="element-131">
                  {tomo.title}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-4" data-id="element-132">
          <CTAButton text="¡Sí, quiero empezar hoy!" data-id="element-133" />
        </div>
      </motion.div>
    </section>;
}